import { createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../api/api';

const registerUser = createAsyncThunk(
  'registration/registerUser',
  async (data: any, thunkAPI) => {
    const response = await API.registration().register(data);
    return response?.data;
  }
);

const validateRegistrationToken = createAsyncThunk(
  'registration/validateRegistrationToken',
  async (token: string, thunkAPI) => {
    const response = await API.registration().validRegistrationToken(token);
    return response?.data;
  }
);

export { registerUser, validateRegistrationToken };
